import { render, staticRenderFns } from "./AdminSteamBotItem.vue?vue&type=template&id=a9247f74&scoped=true&"
import script from "./AdminSteamBotItem.vue?vue&type=script&lang=ts&"
export * from "./AdminSteamBotItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSteamBotItem.vue?vue&type=style&index=0&id=a9247f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9247f74",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QDialog,QCard,QCardSection,QSelect,QCardActions});qInstall(component, 'directives', {ClosePopup});
